import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import UpcomingLessons from './upcoming-lessons'
import RecentLeads from './recent-leads'
import useStyles from './styles'

const ManageBusiness = ({ upcomingLessons, lessonsLoading }) => {
  const classes = useStyles()

  return (
    <Box className={classes.section}>
      <Typography component="h2" className={classes.sectionTitle}>
        Manage your coaching business
      </Typography>
      <Box className={classes.grid}>
        <UpcomingLessons lessons={upcomingLessons} loading={lessonsLoading} />
        <RecentLeads />
      </Box>
    </Box>
  )
}

export default ManageBusiness
